import { createRoute } from "@tanstack/solid-router";
import { appRoute } from "./route";
import { VaultGate } from "@/features/vault/components/vault-gate";
import { VaultHealth } from "@/features/vault/components/vault-health";

/** Salud de seguridad del vault (requiere estar desbloqueado). */
function SecurityPage() {
  return (
    <VaultGate>
      <VaultHealth />
    </VaultGate>
  );
}

export const securityRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/security",
  component: SecurityPage,
});
